import axios from 'axios';
import axiosInstance from './AxiosService';

class AdminRoleService {
    // Get admin roles for an app
    async getAdminRolesByApp(appId) {
        try {
            const response = await axiosInstance.get(`admin-roles/app/${appId}/`);
            return response.data;
        } catch (error) {
            console.error('Error fetching admin roles:', error);
            throw error;
        }
    }
    
    // Get unique roles from an application to help setup
    async getUniqueRolesByApp(appId) {
        try {
            const response = await axiosInstance.get(`admin-roles/get-unique-roles/${appId}/`);
            return response.data;
        } catch (error) {
            console.error('Error fetching unique roles:', error);
            throw error;
        }
    }
    
    // Create new admin role
    async createAdminRole(data) {
        try {
            const response = await axiosInstance.post(`admin-roles/`, data);
            return response.data;
        } catch (error) {
            console.error('Error creating admin role:', error);
            throw error;
        }
    }
    
    // Delete admin role
    async deleteAdminRole(roleId) {
        try {
            const response = await axiosInstance.delete(`admin-roles/${roleId}/`);
            return response.data;
        } catch (error) {
            console.error('Error deleting admin role:', error);
            throw error;
        }
    }
    
    // Get users with admin role
    async getUsersWithAdminRole(roleId) {
        try {
            const response = await axiosInstance.get(`admin-roles/users/${roleId}/`);
            return response.data;
        } catch (error) {
            console.error('Error fetching users with admin role:', error);
            throw error;
        }
    }
    
    // Check if admin roles are configured for an app
    async checkAdminRolesSetup(appId) {
        try {
            const response = await axiosInstance.get(`admin-roles/status/${appId}/`);
            return response.data;
        } catch (error) {
            console.error('Error checking admin roles setup:', error);
            throw error;
        }
    }
    
    // Check HR record status for a user by email
    async checkUserHRStatus(email) {
        try {
            const response = await axiosInstance.get(`hr/data/${email}/`);
            return response.data;
        } catch (error) {
            console.error('Error checking HR status for user:', error);
            // Return a default object if the user doesn't exist in HR records
            return { STATUS: 'Not Found' };
        }
    }
}

export default new AdminRoleService(); 